export const STYLES = {
  CONTAINER: 'flex flex-col h-[658px] w-full rounded-[8px] bg-bw00 mt-[49px] my-[24px]',
  MAIN_TITLE_WRAPPER: 'px-[24px] py-[16px] border-b-[0.8px] border-bw03',
  MAIN_TITLE: 'font-metricR text-[20px] text-bw08',
  TITLE: 'font-metricR text-[24px] text-bw08 mb-[10px]',
  TEXT: 'font-metricR text-[16px] text-bw07',
  CONTENT_BODY: 'flex flex-col items-center justify-center h-full',
  SUBMIT_CTA:
    'font-metricR text-bw00 py-[13px] text-[16px] rounded-[4px] px-[40px] py-[17px] mt-[30px] bg-action03 hover:bg-action04 active:bg-action04',
};
